export default "__VITE_ASSET__NV0peMfc__"